import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import EchartBox from '@blade-sxp/tools/components/echart-box/index.vue';
import { echartData } from '@blade-sxp/tools/config';
let Result = class Result extends Vue {
    percent;
    echartsData = echartData;
    show = false;
    handlePercentChange(val) {
        this.init(val);
    }
    init(val) {
        console.log('val', val);
        this.echartsData.title.text = `{val|${val}}{percent|%}`;
        this.echartsData.series[0].data[0].value = val;
    }
    beforeDestroy() {
        this.init('0');
    }
    mounted() {
        this.init(this.percent);
    }
};
__decorate([
    Prop({ default: '0', type: String })
], Result.prototype, "percent", void 0);
__decorate([
    Watch('percent', { immediate: false })
], Result.prototype, "handlePercentChange", null);
Result = __decorate([
    Component({
        name: 'result',
        components: { EchartBox },
        i18n: {
            messages: {
                en: {
                    title: 'Result',
                    result: 'Similarity'
                },
                zh: {
                    title: '结果',
                    result: '比对结果'
                }
            }
        }
    })
], Result);
export default Result;
